import React from "react";

import { SORT_OPTIONS } from "../accessoryFilters";

const AccessoriesSearchBar = ({
  term,
  onTermChange,
  sort,
  onSortChange,
  located,
  onSubmit,
  activeCount,
  onOpenFilters,
}) => (
  <form
    className="acc-searchbar"
    role="search"
    onSubmit={(event) => {
      event.preventDefault();
      onSubmit();
    }}
  >
    <div className="acc-searchbar-fields">
      <div className="acc-searchbar-field acc-searchbar-what">
        <input
          type="search"
          className={`acc-searchbar-input${term ? " has-clear" : ""}`}
          placeholder="Search any accessory, brand or supplier"
          aria-label="Search accessories"
          value={term}
          onChange={(event) => onTermChange(event.target.value)}
        />

        {term && (
          <button
            type="button"
            className="acc-searchbar-clear"
            aria-label="Clear search"
            onClick={() => onTermChange("")}
          >
            ×
          </button>
        )}
      </div>

      <div className="acc-searchbar-field acc-searchbar-when">
        <select
          className="acc-searchbar-select"
          aria-label="Sort accessories"
          value={sort}
          onChange={(event) => onSortChange(event.target.value)}
        >
          {SORT_OPTIONS.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.needsLocation && !located}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="acc-searchbar-field acc-searchbar-where">
        <button
          type="button"
          className="acc-searchbar-where-button"
          onClick={onOpenFilters}
        >
          More Filters
          {activeCount > 0 && <span className="acc-filter-dot">{activeCount}</span>}
        </button>
      </div>
    </div>

    <button type="submit" className="acc-searchbar-submit" aria-label="Search">
      <img src="/assets/icons/accessories/search.svg" alt="" aria-hidden="true" />
    </button>
  </form>
);

export default AccessoriesSearchBar;
